import {
	initialValues,
	validationSchema,
} from '@/components/Organization/TablesAndTickets/TableDetails/formConfiguration';
import FormContent from '@/components/Organization/TablesAndTickets/TableDetails/FormContent';
import {getEditTableDetailsValues} from '@/components/Organization/TablesAndTickets/TableDetails/helpers';
import {useAppDispatch, useAppSelector} from '@/store/hooks';
import {getTableTickets, getTicketsTableSelector} from '@/store/organization-tables';
import {getErrorMessage} from '@/utils/helpers';
import {OrganizationTableAndTicketsService} from '@/utils/services';
import {IOrganizationTableTicketsRequest, IOrganizationTableTicketsResponse} from '@/utils/types';
import {Box} from '@mui/material';
import {Formik} from 'formik';
import {useEffect, useMemo} from 'react';
import {toast} from 'react-toastify';
import {styles} from './TableDetailsStyle.styles';

import {useParams} from 'react-router-dom';
import {useApiInstance} from '@/contexts/ApiInstanceContext';

const TableDetailsPage = () => {
	const dispatch = useAppDispatch();
	const {id} = useParams();

	const ticketsTable = useAppSelector(getTicketsTableSelector);

	const {apiInstance} = useApiInstance();

	const formikInitialValues = useMemo(() => {
		if (ticketsTable) return ticketsTable;
		return initialValues;
	}, [ticketsTable]);

	const getTableTicketsData = async () => {
		if (!id) return;

		try {
			await dispatch(getTableTickets({reqBody: +id, apiInstance})).unwrap();
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	const handleSubmitClickHandler = async (values: IOrganizationTableTicketsResponse) => {
		try {
			const editValues: IOrganizationTableTicketsRequest = getEditTableDetailsValues(values);
			await OrganizationTableAndTicketsService.updateTableTickets(values.id, editValues, apiInstance);
		} catch (error) {
			toast.error(getErrorMessage(error));
		}
	};

	useEffect(() => {
		if (id) getTableTicketsData();
	}, [id]);

	return (
		<Box sx={styles.wrapper}>
			<Formik
				enableReinitialize
				initialValues={formikInitialValues}
				onSubmit={handleSubmitClickHandler}
				validationSchema={validationSchema}
			>
				<FormContent />
			</Formik>
		</Box>
	);
};

export default TableDetailsPage;
